import { THEME_TYPE } from '../../../../../ui-lib/consts';
import { MAP_VIEW_MODE } from '../../../../../ui-lib/modules/Map/controls/StyleControl/enums/map-view-mode';
import { PREFERENCE_TIME_FORMAT } from '../../../elements/RedesignedHeader/components/UserProfile/components/ProfileDrawerContent/components/TimeFormatRadio/enums/preference-time-format';
import { DISTANCE_UNIT } from '../../../consts/distance-units';
import { PAGE } from '../../../consts/pages';
import { LOCALE_KEY } from '../../../consts/languages';
import { UserPreferencesData } from '../api/types/UserPreferencesData';
import { PREFERENCE } from '../const/preferences';
import {
  SET_USER_PREFERENCES,
  CHANGE_USER_PREFERENCE,
} from '../const/action-types';

export const initialState = {
  [PREFERENCE.LOCALE]: LOCALE_KEY.ENGLISH,
  [PREFERENCE.SOUND]: true,
  [PREFERENCE.SUV_MAP_STYLE]: '',
  [PREFERENCE.SUV_SELECTED_GROUP]: null,
  [PREFERENCE.SUV_SIDEBAR_OPEN]: true,
  [PREFERENCE.TIMEZONE]: 'local',
  [PREFERENCE.TEMPERATURE_UNITS]: 'F',
  [PREFERENCE.DISTANCE_UNIT]: DISTANCE_UNIT.MI,
  [PREFERENCE.DEFAULT_APP]: PAGE.sentinel,
  [PREFERENCE.ASSET_MANAGER_DEFAULT_FILTER_ID]: null,
  [PREFERENCE.TIME_FORMAT]: PREFERENCE_TIME_FORMAT.TWELVE_HRS,
  [PREFERENCE.THEME_MODE]: THEME_TYPE.LIGHT,
  [PREFERENCE.MAP_VIEW_MODE]: MAP_VIEW_MODE.REGULAR,
  needUpdate: false,
};

interface SetPreferencesAction {
  type: 'SET_USER_PREFERENCES';
  payload: Partial<UserPreferencesData>;
}

interface ChangeUserPreferenceAction {
  type: 'CHANGE_USER_PREFERENCE';
  payload: { key: PREFERENCE; value: any };
}

type Action = SetPreferencesAction | ChangeUserPreferenceAction;

export default function userPreferencesReducer(state = initialState, action: Action) {
  switch (action.type) {
    case SET_USER_PREFERENCES:
      return {
        ...state,
        ...action.payload
      };
    case CHANGE_USER_PREFERENCE:
      return {
        ...state,
        needUpdate: true,
        [action.payload.key]: action.payload.value
      };
    default:
      return state;
  }
}
